<template>
  <div>
    <div class="master-detail-caption"></div> 
    <DxDataGrid
      :data-source="data"
      :show-borders="true" key-expr="Id"
      :column-auto-width="true" >
        <DxPaging :page-size="20"/>           
        <DxColumn data-field="ContractCategoryDto.Description" caption="Tύπος σύμβασης" alignment="left"/>
        <DxColumn data-field="YearMonth" caption="Ετος/Μήνας" :group-index="0" alignment="left"/>
        <DxColumn data-field="Start" caption="Εναρξη" alignment="right"/>
        <DxColumn data-field="End" caption="Λήξη" alignment="right"/>
        <DxColumn caption="Ενεργή" data-field="IsActive" data-type="boolean" width="150px" alignment="center"/>         
    </DxDataGrid>
  </div>
</template>
<script>

 import mainService from '../../services/mainService';
 import { DxDataGrid, DxColumn, DxPaging } from 'devextreme-vue/data-grid';

export default {
  components: { DxDataGrid, DxColumn,DxPaging },
  props: {
    templateData: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {      
      return {
          data : [],         
      }  
  },
  async mounted(){      
     await this.getStructureContractCategories();
  },
  methods: {
    async getStructureContractCategories(){    
        var structureId = this.templateData.data.Id;                    
        var res = await mainService.get(`/StructureContractCategories/GetStructureContractCategories?structureId=${structureId}`);      
        this.data= res.data;     
        console.log(this.data);
    },
    
  }
};
</script>

<style>
.master-detail-caption {
    padding: 0 0 5px 10px;
    font-size: 14px;
    font-weight: bold;
}

.dx-header-row{
  font-weight:bold;
}
</style>
